import { useState, useEffect } from "react"
import { useTheme } from "@/components/ThemeProvider"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia("(max-width: 767px)").matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <Sonner
      theme={theme === 'dark' ? 'dark' : 'light'}
      className="toaster group z-[100]"
      style={isMobile ? undefined : { bottom: 'calc(1rem + var(--toast-extra-offset, 0px))' }}
      position={isMobile ? "top-center" : "bottom-right"}
      offset={16}
      richColors
      visibleToasts={6}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg dark:group-[.toaster]:shadow-2xl",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground hover:group-[.toast]:bg-primary/90 group-[.toast]:shadow-sm",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground hover:group-[.toast]:bg-muted/90 group-[.toast]:shadow-sm",
          closeButton:
            "group-[.toast]:text-muted-foreground/50 hover:group-[.toast]:text-muted-foreground group-[.toast]:transition-colors",
          success: "group-[.toast]:border-l-4 group-[.toast]:border-l-emerald-500 dark:group-[.toast]:border-l-emerald-400 group-[.toast]:text-emerald-500 dark:group-[.toast]:text-emerald-400",
          error: "group-[.toast]:border-l-4 group-[.toast]:border-l-destructive group-[.toast]:text-destructive",
          info: "group-[.toast]:border-l-4 group-[.toast]:border-l-primary group-[.toast]:text-primary",
          warning: "group-[.toast]:border-l-4 group-[.toast]:border-l-amber-500 dark:group-[.toast]:border-l-amber-400 group-[.toast]:text-amber-500 dark:group-[.toast]:text-amber-400",
        },
      }}
      {...props}
    />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export { Toaster, toast }
